import React from 'react'
import Navbar from './Navbar'
import { Link } from "react-router-dom";

const ViewHome = () => {
  return (
    <>
      <div className='p-3 mb-2 text-white'>
        <Navbar />
        <div className="container-home mt-4">
          <h1 className="title-home">Seguros Automovilísticos</h1>
          <p className='mt-4'>Los seguros no se piensan, se toman</p>
          <p>porque los siniestros no se planean, llegan.</p>
          <img className="img-girl-car" src="https://user-images.githubusercontent.com/89402461/157266021-ea878fcb-a8b2-42b8-8b53-bd3175cc9d59.jpg" alt="img seguro" />
          <Link to="/Login">
            <button type="submit" className="btn-home form-control mt-4" width="500" heigth="400">Inicia tu sesión</button>
          </Link>
          <div id='face'>
          <img className='mt-4 mx-5' src="https://user-images.githubusercontent.com/89401079/157549495-1399561f-8e59-485b-a19d-84c74261d685.png" width="50" height="50" alt="Logo Ey" />
          </div>
          <p id='faceText'>Reconocimiento Facial(pronto)</p>
        </div>
      </div>
    </>
  )
}

export default ViewHome